export default "__VITE_ASSET__ea797e2f__"